module.exports = __webpack_public_path__ + "static/media/google_store.9de6baf6.svg";